/**
 * Blog article behaviour: tabbed blocks and the mobile contents accordion.
 *
 * Article bodies are pasted into the admin as raw HTML, so these controls are
 * bound through delegation on document rather than by querying elements at load
 * — the markup they act on is authored per article and cannot be relied on to
 * exist, or to be unique, on any given page.
 */

const TAB_SELECTOR = '[data-tab]'
const TABS_ROOT = '[data-tabs]'
const TOC_TRIGGER = '[data-toc-trigger]'

function activateTab (button) {
  const root = button.closest(TABS_ROOT)

  if (!root) {
    return
  }

  const id = button.getAttribute('data-tab')

  root.querySelectorAll(TAB_SELECTOR).forEach((other) => {
    other.setAttribute('aria-selected', String(other === button))
  })

  root.querySelectorAll('[data-panel]').forEach((panel) => {
    panel.hidden = panel.getAttribute('data-panel') !== id
  })
}

function toggleContents (trigger) {
  // The accordion body is the trigger's sibling, so several articles' worth of
  // markup on one page cannot cross-wire.
  const body = trigger.parentElement && trigger.parentElement.querySelector('[data-toc-body]')

  if (!body) {
    return
  }

  const opening = body.hidden

  body.hidden = !opening
  trigger.setAttribute('aria-expanded', String(opening))

  const sign = trigger.querySelector('.toc-accordion__sign')

  if (sign) {
    sign.textContent = opening ? '–' : '+'
  }
}

export default function initBlog () {
  document.addEventListener('click', (event) => {
    const tab = event.target.closest && event.target.closest(TAB_SELECTOR)

    if (tab) {
      activateTab(tab)
      return
    }

    const trigger = event.target.closest && event.target.closest(TOC_TRIGGER)

    if (trigger) {
      toggleContents(trigger)
    }
  })
}
